import "../key/constants.js";
import { isPhysicalModifier as a } from "../key/guards.js";
import { compareKeys as f, createKey as u } from "../key/utils.js";
const n = {
  Tilde: { acceptedTriggerIds: ["Backquote"] },
  Exclamation: { acceptedTriggerIds: ["Digit1"] },
  At: { acceptedTriggerIds: ["Digit2"] },
  Hash: { acceptedTriggerIds: ["Digit3"] },
  Dollar: { acceptedTriggerIds: ["Digit4"] },
  Percent: { acceptedTriggerIds: ["Digit5"] },
  Caret: { acceptedTriggerIds: ["Digit6"] },
  Ampersand: { acceptedTriggerIds: ["Digit7"] },
  Asterisk: { acceptedTriggerIds: ["Digit8"] },
  LeftParen: { acceptedTriggerIds: ["Digit9"] },
  RightParen: { acceptedTriggerIds: ["Digit0"] },
  Underscore: { acceptedTriggerIds: ["Minus"] },
  Plus: { acceptedTriggerIds: ["Equal", "Plus"] },
  LeftBrace: { acceptedTriggerIds: ["BracketLeft"] },
  RightBrace: { acceptedTriggerIds: ["BracketRight"] },
  Pipe: { acceptedTriggerIds: ["Backslash"] },
  Colon: { acceptedTriggerIds: ["Semicolon"] },
  DoubleQuote: { acceptedTriggerIds: ["Quote"] },
  LessThan: { acceptedTriggerIds: ["Comma"] },
  GreaterThan: { acceptedTriggerIds: ["Period"] },
  QuestionMark: { acceptedTriggerIds: ["Slash"] }
};
function o(e) {
  return e === "Primary" || e === "Shift" || e === "Alt";
}
function h(e) {
  return Object.hasOwn(n, e);
}
function p(e) {
  const t = [];
  for (const r of e) {
    const i = String(r.id);
    o(i) && t.push(i);
  }
  return t;
}
function m(e, t) {
  return `${e.join("+")}|${t}`;
}
function S(e) {
  return h(e) ? n[e].acceptedTriggerIds : [e];
}
function l(e) {
  const t = e.some((r) => String(r.id) === "Shift");
  return e.map((r) => {
    const i = String(r.id);
    return o(i) ? i : i === "Equal" && !t ? "Plus" : i;
  }).join("+");
}
function d(e) {
  if (e === "Control" || e === "Meta")
    throw new Error(`Unsupported modifier "${e}". Use "Primary" instead.`);
  if (a(e))
    throw new Error(
      `Physical modifier "${e}" is not allowed. Use "Primary", "Shift", or "Alt".`
    );
}
function T(e) {
  const t = e.length - 1, r = e[t];
  if (!r || o(String(r.id)))
    throw new Error("Shortcut must contain exactly one non-modifier trigger key.");
  for (let i = 0; i < t; i += 1) {
    const c = e[i];
    if (!c || !o(String(c.id)))
      throw new Error("Shortcut must contain exactly one non-modifier trigger key.");
  }
}
function s(e) {
  const t = typeof e == "string" ? e : e && typeof e == "object" && "id" in e ? e.id : void 0;
  if (typeof t != "string")
    throw new Error("Shortcut must be created with createShortcut(...).");
  return u(t);
}
function I(e) {
  if (!Array.isArray(e))
    throw new Error("Binding shortcut must be created with createShortcut(...).");
  if (e.length === 0)
    throw new Error("Shortcut must contain exactly one non-modifier trigger key.");
  const t = /* @__PURE__ */ new Set(), r = e.map(s).sort(f);
  for (const i of r) {
    const c = String(i.id);
    if (d(c), !!o(c)) {
      if (t.has(c))
        throw new Error(`Shortcut contains duplicate modifier "${c}".`);
      t.add(c);
    }
  }
  return T(r), r;
}
function P(e) {
  const t = e[e.length - 1], r = p(e);
  return {
    acceptedEventKeys: S(String(t.id)).map(
      (g) => m(r, g)
    ),
    duplicateShortcutId: l(e)
  };
}
function D(...e) {
  for (const t of e)
    d(String(t));
  return I(e.map((t) => s(t)));
}
export {
  P as compileShortcut,
  D as createShortcut,
  m as getEventMatchKey,
  o as isShortcutModifier,
  I as normalizeShortcut
};
